import React from "react";

export default function Pagination({
  offset,
  limit,
  totalMotors,
  options,
  errorMessage,
  MAX_DISPLAY_LIMIT,
  onPrevious,
  onNext,
  onLimitChange,
  onCustomLimitChange,
}) {
  const totalPages = Math.ceil(totalMotors / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  return (
    <div className="flex flex-col space-y-6 lg:mb-8 lg:space-y-0 lg:flex-row lg:items-center lg:justify-between w-full px-4 py-3 bg-gray-100 rounded-lg shadow-md">
      <div className="text-sm font-medium text-bleuSTB">
        Nombre total de moteur{totalMotors > 1 ? "s" : ""} :{" "}
        <span className="font-bold">{totalMotors}</span>
      </div>

      {/* Sélecteur preset */}
      <div className="flex flex-col space-y-2 lg:flex-row lg:items-center lg:space-y-0 lg:space-x-2">
        <label htmlFor="limit" className="text-sm font-medium text-bleuSTB">
          Moteurs par page :
        </label>
        <select
          id="limit"
          value={limit}
          onChange={onLimitChange}
          className="w-full lg:w-28 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm"
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      {/* Sélecteur personnalisé */}
      <div className="flex flex-col space-y-2 lg:flex-row lg:items-center lg:space-y-0 lg:space-x-2">
        <label htmlFor="customLimit" className="text-sm font-medium text-bleuSTB">
          Personnalisé :
        </label>
        <input
          type="number"
          id="customLimit"
          min="1"
          max={Math.min(MAX_DISPLAY_LIMIT, totalMotors)}
          placeholder="Ex : 15"
          onChange={onCustomLimitChange}
          className={`w-full lg:w-28 px-3 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm ${
            errorMessage ? "border-red-500" : "border-gray-300"
          }`}
        />
      </div>

      {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}

      {/* Navigation */}
      <div className="flex items-center space-x-4">
        <button
          onClick={onPrevious}
          disabled={offset === 0}
          className={`px-4 py-2 rounded-lg text-sm font-medium ${
            offset === 0
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-bleuSTB text-white hover:bg-marronSTB"
          }`}
        >
          Précédent
        </button>
        <span className="text-sm text-bleuSTB">
          Page {currentPage} sur {totalPages}
        </span>
        <button
          onClick={onNext}
          disabled={offset + limit >= totalMotors}
          className={`px-4 py-2 rounded-lg text-sm font-medium ${
            offset + limit >= totalMotors
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-bleuSTB text-white hover:bg-marronSTB"
          }`}
        >
          Suivant
        </button>
      </div>
    </div>
  );
}